<script lang="ts">
  // Dezenter Seiten-Fuss unten mittig: Build des laufenden Backends plus
  // Ladezeit dieses Aufrufs; Details im Tooltip. Rein informativ.
  //
  // Die Werte kommen aus lib/version-info.svelte.ts -- dieselbe Quelle,
  // aus der die Statusleiste der Shell ihre kompakte Fassung zieht.
  import { onMount } from "svelte";
  import { t } from "./i18n.svelte";
  import {
    buildZeit as fmtBuild,
    getLadezeit,
    getVersionInfo,
    ms,
    startVersionInfo,
  } from "./version-info.svelte";

  onMount(startVersionInfo);

  const v = $derived(getVersionInfo());
  const load = $derived(getLadezeit());

  const loadTip = $derived(
    load
      ? [
          `${t("footer.load.backend", "Backend")} ${ms(load.server)}`,
          `${t("footer.load.transfer", "Übertragung")} ${ms(load.transfer)}`,
          `${t("footer.load.render", "Aufbau im Browser")} ${ms(load.build)}`,
        ].join(" · ")
      : "",
  );

  const tip = $derived(
    v
      ? [
          v.commit ? `Commit ${v.commit}` : "",
          v.go_version ? `Go ${v.go_version}` : "",
          `Svelte ${__STACK_VERSIONS__.svelte}`,
          `Vite ${__STACK_VERSIONS__.vite}`,
          `TS ${__STACK_VERSIONS__.typescript}`,
        ]
          .filter(Boolean)
          .join(" · ")
      : "",
  );
</script>

<!-- mt-auto schiebt den Footer in der Flex-Spalte der App-Shell immer an den
     unteren Bildrand (bei kurzem Inhalt), fliesst sonst hinter dem Inhalt. -->
<footer class="text-fg-subtle/70 mt-auto px-4 pb-4 pt-8 text-center t-meta">
  <span class="font-medium">homelab-dash</span>
  {#if v}
    <span class="opacity-50"> · </span>
    <span class="tabular-nums" title={tip}>
      {v.version || v.commit || ""} · Build {fmtBuild(v.build_time)}
    </span>
  {/if}
  {#if load}
    <span class="opacity-50"> · </span>
    <span class="tabular-nums" title={loadTip}>
      {t("footer.load.total", "Geladen in")}
      {ms(load.total)}
    </span>
  {/if}
</footer>
